
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ServiceLocator } from '../../app/ServiceLocator';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { Resource } from '../../ts/resources/Resource';
import { IGroupInfo, IGetGroupDetailInfoResult } from '../../ts/models/IGroupInfo';
import { GetGroupsRequest } from '../../ts/ServerApi/requests/GetGroupsRequest';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { ServerService } from '../../ts/services/ServerService';
import { GrantLicenseModes } from '../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ICreateGroupParams, CreateGroupRequest } from '../../ts/ServerApi/requests/CreateGroupRequest';
import { DeleteGroupsRequest } from '../../ts/ServerApi/requests/DeleteGroupsRequest';
import { IUpdateGroupNameParams, UpdateGroupNameRequest } from '../../ts/ServerApi/requests/UpdateGroupNameRequest';
import { IGetGroupDetailsParams, GetGroupDetailsRequest } from '../../ts/ServerApi/requests/GetGroupDetailsRequest';
import { UpdateGroupsMinimumSiteRoleRequest } from '../../ts/ServerApi/requests/UpdateGroupsMinimumSiteRoleRequest';
import { RequestHelper } from '../../ts/helpers/RequestHelper';
import { ResultHelper } from '../../ts/helpers/ResultHelper';

export class GroupsResource extends Resource<IGroupInfo> {

  constructor() {
    super(new WebClientListResourceFetcher(GetGroupsRequest, ServerApiMapper.groups));
  }

  // Actions

  private getErrorNotifyingServer(): ErrorNotifyingServer {
    return ServiceLocator.get<ErrorNotifyingServer>('ErrorNotifyingServer');
  }

  private getServerService(): ServerService {
    return ServiceLocator.get<ServerService>('ServerService');
  }

  // create new group
  public createGroup(groupName: string, grantLicenseMode?: GrantLicenseModes, minimumSiteRole?: string): Promise<IResult> {
    const params: ICreateGroupParams = {
      name: groupName,
      grantLicenseMode: grantLicenseMode,
      siteRole: minimumSiteRole
    };
    return toNativePromise(this.getErrorNotifyingServer().sendRequestAndDelay(new CreateGroupRequest(params)));
  }

  // delete groups
  public deleteGroups(ids: string[]): Promise<IResult> {
    return toNativePromise(
      this.getErrorNotifyingServer().sendRequestsAndDelay(
        RequestHelper.buildRequests(ids, (idsBlock) => new DeleteGroupsRequest(idsBlock)),
        ResultHelper.combineResults)
    );
  }

  // update group name
  public updateGroupName(groupId: string, name: string): Promise<IResult> {
    const params: IUpdateGroupNameParams = {
      groupId: groupId,
      name: name
    };
    return toNativePromise(this.getErrorNotifyingServer().sendRequestAndDelay(new UpdateGroupNameRequest(params)));
  }

  // get group details
  public getGroupDetails(groupId: string): Promise<IGetGroupDetailInfoResult> {
    const params: IGetGroupDetailsParams = {
      id: groupId
    };
    return toNativePromise(
      this.getServerService().sendRequest(new GetGroupDetailsRequest(params)).then((result) => {
        const groupInfo: IGetGroupDetailInfoResult = {
          ...result,
          contentType: 'group'
        };
        return groupInfo;
      })
    );
  }

  public updateGroupsMinimumSiteRole(groupIds: string[], siteRole: string, grantLicenseMode: GrantLicenseModes): Promise<IResult> {
    return toNativePromise(
      this.getErrorNotifyingServer().sendRequestsAndDelay(
        RequestHelper.buildRequests(groupIds, (idsBlock) => {
          return new UpdateGroupsMinimumSiteRoleRequest({
            groupIds: idsBlock,
            minimumSiteRole: siteRole,
            grantLicenseMode: grantLicenseMode
          });
        }),
        ResultHelper.combineResults
      )
    );
  }

}

export const Groups = new GroupsResource;
